import { axiosClientServices as axiosClient } from "@duosoftbg/nacid-frontoffice-components";

const endpoints = {
  filterPreviousSubmitted: "/se-recognition/filter-previous-submitted",
  applicationKind: "/se-recognition/application-kind/",
};

export const filterPreviousSubmitted = (filter) => () => {
  return axiosClient.post(`${endpoints.filterPreviousSubmitted}`, filter);
};

export const getApplicationKind = (id) => () => {
  return axiosClient.get(`${endpoints.applicationKind}${id}`);
};
